import { useState, useEffect } from 'react';

export function UpdateBadge() {
  const [version, setVersion] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!window.electronAPI?.updater) return;
    return window.electronAPI.updater.onReady(({ version: v }) => setVersion(v));
  }, []);

  if (!version) return null;

  return (
    <div className="relative flex flex-col items-center w-full px-2 py-1 gap-1 group">
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Actualización disponible"
        className="relative w-10 h-10 rounded-xl flex items-center justify-center text-ink-muted group-hover:bg-surface-hover group-hover:text-ink transition-colors"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
        <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-accent">
          <span className="absolute inset-0 rounded-full bg-accent animate-ping opacity-75" />
        </span>
      </button>
      <span className="text-[10px] font-medium w-full text-center truncate leading-tight transition-colors text-ink-muted group-hover:text-ink-soft">Actualizar</span>

      {open && (
        <>
          <div className="fixed inset-0 z-50" onClick={() => setOpen(false)} />
          <div className="absolute bottom-0 left-14 z-50 w-64 bg-surface-card border border-stroke rounded-xl shadow-lg p-4 flex flex-col gap-3">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-accent/10 flex items-center justify-center flex-none">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-accent">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-semibold text-ink">Proclaim {version}</p>
                <p className="text-xs text-ink-muted mt-0.5">Listo para instalar</p>
              </div>
            </div>
            <button
              onClick={() => window.electronAPI!.updater.install()}
              className="w-full h-9 rounded-lg bg-accent text-white text-sm font-semibold hover:bg-accent-hover active:scale-[0.98] transition-all"
            >
              Reiniciar y actualizar
            </button>
            <button
              onClick={() => setOpen(false)}
              className="w-full h-8 rounded-lg text-ink-muted text-xs hover:bg-surface-hover transition-colors"
            >
              Más tarde
            </button>
          </div>
        </>
      )}
    </div>
  );
}
